import React, { CSSProperties, FunctionComponent } from "react";
import { Box, Text } from "grommet";
import StandardColors from "../../../../../util/StandardColors";
import StandardFonts from "../../../../../util/StandardFonts";

type ChipsPropsType = {
  title: string;
  backgroundColor?: string;
  fontColor?: string;
  containerStyle?: CSSProperties;
};

const Chip: FunctionComponent<ChipsPropsType> = ({
  title,
  backgroundColor,
  fontColor,
  containerStyle,
}: ChipsPropsType) => {
  return (
    <Box
      style={{
        ...styles.container,
        backgroundColor,
        ...containerStyle,
      }}
    >
      <Text
        style={{
          ...styles.textStyle,
          color: fontColor,
        }}
      >
        {title}
      </Text>
    </Box>
  );
};

Chip.defaultProps = {
  title: "",
  fontColor: "#41454B",
  backgroundColor: "#F2F7FF",
  containerStyle: {},
};

export default Chip;

const styles = {
  container: {
    alignItems: "center",
    justifyContent: "center",
    borderRadius: 100,
    paddingTop: 6,
    paddingBottom: 6,
    paddingLeft: 12,
    paddingRight: 12,
  },
  textStyle: {
    ...StandardFonts.capture1016Medium,
    fontSize: 12,
  },
};
